/**
* DO NOT EDIT MANUALLY
* This is an auto-generated file.
* Any changes will be overwritten.
*/
import{i as a}from"./lit-element-3JpVCGI4.js";const n=a`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  @media (max-width: 500px) {
    .sm\\:sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border-width: 0;
    }
  }

  @media (max-width: 768px) {
    .md\\:sr-only {
      @media (max-width: 1024px) {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border-width: 0;
      }
    }
  }

  .action_bar {
    display: flex;
    align-items: center;
    gap: calc(2 * var(--space-unit));
    justify-content: space-between;

    h2 {
      word-break: keep-all;
    }

    button {
      flex-shrink: 1;
    }
  }
`,i=a`
  h2 {
    text-transform: uppercase;
    letter-spacing: 0.1em;
    margin-block: 0;
    font-size: calc(var(--h5-font-size));
    font-family: var(--navigation-font-family);
    font-style: var(--navigation-font-style);
    font-weight: var(--navigation-font-weight);
    line-height: 1;

    @media (min-width: 500px) {
      font-size: calc(var(--h3-font-size));
    }

    @media (min-width: 769px) {
      font-size: var(--h1-font-size);
    }
  }
`,e=a`
  .button__primary {
    display: flex;
    align-items: center;
    gap: calc(1 * var(--space-unit));
    background-color: white;
    border-radius: 24px;
    border: none;
    color: #e01a1a;
    cursor: pointer;
    border: 2px solid transparent;
    font-family: var(--navigation-font-family);
    font-style: var(--navigation-font-style);
    font-size: calc(var(--body-font-size) * 0.75 * 0.1rem);
    font-weight: var(--navigation-font-weight);
    letter-spacing: 0.1em;
    padding: calc(2 * var(--space-unit)) calc(3 * var(--space-unit));
    text-transform: uppercase;
    justify-content: center;
    transition: all 0.2s ease-in-out;
    white-space: nowrap;

    &:has(kanter-icon) {
      padding: calc(2 * var(--space-unit)) calc(3 * var(--space-unit))
        calc(2 * var(--space-unit)) calc(2 * var(--space-unit));
    }

    @media (min-width: 769px) {
      &:not(vaadin-menu-bar-button) {
        font-size: calc(var(--body-font-size) * 0.1rem);
        gap: calc(2 * var(--space-unit));
        padding: calc(2 * var(--space-unit)) calc(8 * var(--space-unit));
      }

      &:has(kanter-icon) {
        padding: calc(2 * var(--space-unit)) calc(8 * var(--space-unit))
          calc(2 * var(--space-unit)) calc(7 * var(--space-unit));
      }
    }

    &:not([disabled]):hover,
    &:not([disabled]):focus-visible {
      --icon-color: 255, 255, 255;
      background-color: transparent;
      border-color: white;
      color: white;
    }

    &[disabled] {
      cursor: default;
      background-color: rgba(255, 255,255, 0.5);
      color: rgba(224, 26, 26, 1);
    }
  }

  .button__secondary {
    display: flex;
    align-items: center;
    gap: calc(1 * var(--space-unit));
    background-color: transparent;
    border-radius: 24px;
    border: 2px solid white;
    color: white;
    cursor: pointer;
    font-family: var(--navigation-font-family);
    font-size: calc(var(--body-font-size) * 0.75 * 0.1rem);
    font-style: var(--navigation-font-style);
    font-weight: var(--navigation-font-weight);
    letter-spacing: 0.1em;
    padding: calc(2 * var(--space-unit)) calc(3 * var(--space-unit));
    text-transform: uppercase;
    justify-content: center;
    transition: all 0.2s ease-in-out;
    white-space: nowrap;

    &:has(kanter-icon) {
      padding: calc(2 * var(--space-unit)) calc(3 * var(--space-unit))
        calc(2 * var(--space-unit)) calc(2 * var(--space-unit));
    }

    @media (min-width: 769px) {
      &:not(vaadin-menu-bar-button) {
        font-size: calc(var(--body-font-size) * 0.1rem);
        gap: calc(2 * var(--space-unit));
        padding: calc(2 * var(--space-unit)) calc(8 * var(--space-unit));
      }

      &:has(kanter-icon) {
        padding: calc(2 * var(--space-unit)) calc(8 * var(--space-unit))
          calc(2 * var(--space-unit)) calc(7 * var(--space-unit));
      }
    }

    &:hover,
    &:focus-visible {
      border-color: white;
      background-color: white;
      color: #e01a1a;
    }
  }

  .button__icon {
    display: flex;
    align-items: center;
    gap: calc(1 * var(--space-unit));
    background-color: transparent;
    border-radius: 24px;
    border: 2px solid transparent;
    color: white;
    cursor: pointer;
    font-family: var(--navigation-font-family);
    font-size: calc(var(--body-font-size) * 0.75 * 0.1rem);
    font-style: var(--navigation-font-style);
    font-weight: var(--navigation-font-weight);
    letter-spacing: 0.1em;
    padding: calc(2 * var(--space-unit)) calc(3 * var(--space-unit));
    text-transform: uppercase;
    justify-content: center;
    transition: all 0.2s ease-in-out;
    white-space: nowrap;

    @media (min-width: 769px) {
      &:not(vaadin-menu-bar-button) {
        font-size: calc(var(--body-font-size) * 0.1rem);
        gap: calc(2 * var(--space-unit));
        padding: calc(2 * var(--space-unit)) calc(8 * var(--space-unit));
      }
    }

    &:hover,
    &:focus-visible {
      border-color: white;
      color: #e01a1a;
    }

    --icon-pad: 2.4rem;
    aspect-ratio: 1 /1;
    padding: 0;

    &:has(kanter-icon) {
      padding: 0;
    }

    @media (min-width: 769px) {
      &:not(vaadin-menu-bar-button) {
        padding: 0;
      }
    }
  }
`;export{e as b,i as h,n as u};
